import {
  IconButton,
  Dialog,
  DialogTitle,
  AppBar,
  Toolbar,
  Typography,
  Box,
  CircularProgress,
  DialogContent,
  DialogActions,
  Tooltip,
  Button,
  TextField,
  Autocomplete,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Menu,
  MenuItem,
  ListItem,
  ListItemAvatar,
  Checkbox,
  ListItemText,
  Fab,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";

import axios from "axios";
import moment from "moment";
import defaultPofile from "../../../assets/default-profile.jpg";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import MaskedInput from "react-text-mask";
import joi from "joi";
import { showError } from "../../../toastify";

import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const TrainingProviderProgramsDialog = (props) => {
  const { user, loading, onWait, trainingProvider } = props;

  const [isLoading, setIsLoading] = useState(true);

  const [providerPrograms, setProviderPrograms] = useState([]);

  const getTrainingProviderPrograms = async () => {
    try {
      setIsLoading(true);

      const { data } = await axios.get(
        `/api/cpd/training-provider-programs/${trainingProvider.id}`,
      );

      setProviderPrograms(data);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTrainingProviderPrograms();
  }, [trainingProvider]);

  return (
    <>
      <div className="bg-white mx-0 p-3 rounded border">
        {!!providerPrograms.length ? (
          <table className="table">
            <thead>
              <tr>
                {/* <th scope="col">#</th> */}
                <th scope="col" colSpan={2}>
                  CPD Arears
                </th>
              </tr>
            </thead>

            <tbody>
              {providerPrograms.map((providerProgram, index) => (
                <tr>
                  <td className="text-left">{index + 1}</td>
                  <td className="text-left">{providerProgram.programName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="jumbotron jumbotron-fluid text-center">
            <div className="container">
              <p className="lead">
                {loading ? "Fetching data..." : "No record found"}{" "}
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({ user, loading, onWait }) => {
  return {
    user,
    loading,
    onWait,
  };
};
export default connect(mapStateToProps, {})(TrainingProviderProgramsDialog);
